


































# import settings from '@/settings'
import t from '@/utils/tools'

export default {
    name: 'knowledges'

    props: ['payload', 'deletions']

    watch:
        payload: (new_item, old_item)->
            # console.log "WATCH ", new_item, old_item
            if Object.keys(@payload).length == 0
                @add_knowledge()

    data: ()->
        min: 0
        max: 10
        false: false
        knowledge: {
            uid: ''
            name: ''
            skill_type: 'knowledge'
            slug: ''
            level_waited: 5
            mandatory: false
        }

    methods:
        deep_copy: t.deep_copy

        remove_knowledge: (index)->
            if @payload[index]['uid'] != ""
                @deletions.push(@payload[index]['uid'])
            # console.log "DELETIONS K : ", @deletions
            if Object.keys(@payload).length > 1
                @payload.splice(index, 1)
            else
                @payload[0].name = ""
                @payload[0].level_waited = 1
                # console.log "FIRST KNOWLEDGE"

        add_knowledge: ()->
            @payload.push(@deep_copy(@knowledge))
        
    beforeMount: ()->
        # console.log "KNOWLEDGES COMPONENT : ", @payload
        if Object.keys(@payload).length == 0
            @add_knowledge()

}

